import { render, staticRenderFns } from "./GoodsMarketResults.vue?vue&type=template&id=aebbb2b0"
import script from "./GoodsMarketResults.vue?vue&type=script&lang=js"
export * from "./GoodsMarketResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports